var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"form-error"},[(_vm.hasMessageSlot)?_vm._t("default"):_c('span',[_vm._v(_vm._s(_vm.error)),(_vm.$listeners.override)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('override')}}},[_vm._v(", "),_c('strong',[_vm._v("foutmelding negeren")])]):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }